import React from 'react';

export const CogIcon = ({ className, ...props }) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 60 60"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    className={className}
    {...props}
  >
    <path
      fill="currentColor"
      d="M25.82 0l-2.08 7.29a23.44 23.44 0 0 0-5.37 2.21l-6.61-3.66-5.92 5.92 3.66 6.61a23.44 23.44 0 0 0-2.22 5.37L0 25.82v8.35l7.29 2.09a23.44 23.44 0 0 0 2.21 5.37l-3.66 6.61 5.92 5.92 6.61-3.66a23.43 23.43 0 0 0 5.37 2.22L25.82 60h8.35l2.09-7.29a23.43 23.43 0 0 0 5.37-2.22l6.61 3.66 5.92-5.92-3.66-6.6a23.44 23.44 0 0 0 2.22-5.37L60 34.18v-8.36l-7.29-2.09a23.44 23.44 0 0 0-2.22-5.37l3.66-6.61-5.91-5.91-6.61 3.66a23.44 23.44 0 0 0-5.37-2.22L34.18 0h-8.36zM30 19.09A10.91 10.91 0 1 1 19.09 30 10.91 10.91 0 0 1 30 19.09z"
    />
  </svg>
);
